export default __webpack_public_path__ + "static/media/134.2549824c.png";